import { getGraph } from '../../lib/getGraph';
const uuidV4 = require('uuid/v4');


const SAVE_FORM_ATTEMPT = "SAVE_FORM_ATTEMPT"
const SAVE_FORM_FAILURE = "SAVE_FORM_FAILURE"
const SAVE_FORM_SUCCESS = "SAVE_FORM_SUCCESS"

export const saveFormAttempt = (payload) => ({ type: SAVE_FORM_ATTEMPT, payload: payload });
export const saveFormSuccess = (payload) => ({ type: SAVE_FORM_SUCCESS, payload: payload });
export const saveFormFailure = (payload) => ({ type: SAVE_FORM_FAILURE, payload: payload });

let initial = {
}

export const formReducer = (state, action) => {
    state = state==null ? initial : state
    switch (action.type) {
        case SAVE_FORM_ATTEMPT:
            console.log("SAVE_FORM_ATTEMPT: " + action.payload)
            return Object.assign({}, state, { [action.payload]: { loading: true } } )
        case SAVE_FORM_SUCCESS:
            return Object.assign({}, state, { [action.payload.data.saveForm.form.slug]: { success: action.payload.data.saveForm, loading: false, errors: false } } )
        case SAVE_FORM_FAILURE:
            return state
        default:
            return state;
    }
};

export const saveForm = (values) => {
    return dispatch => {
        dispatch(saveFormAttempt(values.form));
        return getGraph({
            operationName: "saveFormMutation",
            payload: `mutation saveFormMutation($input: SaveFormInput!) {
                        saveForm( input: $input ) {
                            clientMutationId
                            form {
                                title
                                slug
                            }
                            feedback {
                                db_id
                                name
                                email
                                body
                            }
                        }
                     }`,
            variables: { "input": { "name": values.name, "phone": values.phone, "email": values.email, form: values.form, "body": values.body, "gRecaptchaResponse": values.gRecaptchaResponse , "clientMutationId": uuidV4() } }
        }).then(response => { 
            // console.log(JSON.parse(response).data.saveForm.feedback.body);
            dispatch(saveFormSuccess(JSON.parse(response)));
        })
    }
}


export default formReducer



// WEBPACK FOOTER //
// ./src/components/forms/reducer.js